import { type BundledLanguage, codeToHtml } from 'shiki';

export async function highlightCode(code: string, lang: BundledLanguage): Promise<string> {
  return codeToHtml(code, {
    lang,
    themes: {
      light: 'github-light',
      dark: 'github-dark',
    },
  });
}
